import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class EventEditHistoryService {

  baseURL = environment.baseAPIURL;
    constructor( private readonly http  : HttpClient) {
    }

    private handleError(error: HttpErrorResponse) {
      return throwError(error.message || "Server Error");
    }

    loadEventEditHistory(eventId): Observable<any> { 
        return this.http.get(`${this.baseURL}/aetDashBoard/getEventEditHistory/${eventId}`, { responseType: 'json' })
			.pipe(catchError(this.handleError));
    }
}
